const relativeTimeFormat = new Intl.RelativeTimeFormat('en', {
  numeric: 'auto',
});

const relativeTimeUnits: { [unit: string]: number } = {
  year: 24 * 60 * 60 * 1000 * 365,
  month: (24 * 60 * 60 * 1000 * 365) / 12,
  day: 24 * 60 * 60 * 1000,
  hour: 60 * 60 * 1000,
  minute: 60 * 1000,
  second: 1000,
};

export function getRelativeTime(d1: number, d2: number = +new Date()) {
  const elapsed = d1 - d2;

  // "Math.abs" accounts for both "past" & "future" scenarios
  for (const u of Object.keys(relativeTimeUnits)) {
    if (Math.abs(elapsed) > relativeTimeUnits[u] || u === 'second') {
      return relativeTimeFormat.format(
        Math.round(elapsed / relativeTimeUnits[u]),
        // @ts-ignore
        u,
      );
    }
  }
  return '';
}
